/* global FB */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import * as LoginSignupEvents from 'core/script/app/ui/layout/login-signup-events';
import * as loginAnalytics from 'core/script/app/ui/layout/login-signup-analytics';
import { Analytics } from 'packages';
import logger from 'packages/logger';
import GdprSettings from 'tradera-utils/gdpr-settings';
import { withTranslator } from 'static/script/app/lang';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import FacebookIcon from '@tradera/blueprint/theme/icons2/facebook.svg?jsx';

class FacebookLoginButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.gdprSettings = GdprSettings;
        this.state = {
            enabled: false,
            cookiesEnabled: this.gdprSettings.isFunctionalEnabled(),
            showCookieWarning: false
        };
    }

    onClick = () => {
        const { isModal } = this.props;
        const { cookiesEnabled } = this.state;

        if (!cookiesEnabled) {
            this.setState({ showCookieWarning: true });
            return;
        }

        // ga tracking?
        if (isModal) {
            Analytics.trackEvent({
                category: 'Top navigation',
                action: 'Login menu',
                label: 'Button - Facebook login'
            });
        }

        loginAnalytics.flow.set(loginAnalytics.FLOW.LOGIN);
        loginAnalytics.method.set(loginAnalytics.METHOD.FACEBOOK);
        loginAnalytics.trackEvent('user-login-submit');

        const onLogin = async loginResponse => {
            if (loginResponse.status !== 'connected') {
                return;
            }
            try {
                let verifyResponse = await axios.post(
                    '/login/facebook/verify' + window.location.search,
                    {
                        accessToken: loginResponse.authResponse.accessToken,
                        userId: loginResponse.authResponse.userID
                    }
                );
                LoginSignupEvents.trackLoginSuccess(
                    verifyResponse.data.memberId
                );
                window.parent.location = verifyResponse.data.returnUrl;
            } catch (err) {
                LoginSignupEvents.trackLoginFailure('facebook-auth');
                window.parent.location = '/login?connect=Facebook';
            }
        };

        window.FB.login(onLogin, {
            scope: 'public_profile,email'
        });
    };

    componentDidMount() {
        const { facebookAppId } = this.props;
        if (!facebookAppId) {
            logger(
                'FacebookLogin must have a Facebook App Id (use attribute data-facebook-app-id="{APP_ID}")'
            );
            return;
        }

        window.fbAsyncInit = () => {
            if (window.FB) {
                window.FB.init({
                    appId: facebookAppId,
                    version: 'v2.9'
                });
                this.setState({ enabled: true });
            }
        };
    }

    render() {
        const { enabled, showCookieWarning, cookiesEnabled } = this.state;
        const { t } = this.props;
        return (
            <Fragment>
                {showCookieWarning ? (
                    <div className="alert alert-danger text-left mb-3">
                        <h4>
                            <InfoIcon className="icon icon-lg align-text-bottom mr-2" />{' '}
                            {t('fblogin_cookieMissingWarningTitle')}
                        </h4>
                        <p>{t('fblogin_cookieMissingWarning')}</p>
                    </div>
                ) : null}
                <button
                    className={
                        'btn btn-fluid text-white facebook my-2' +
                        (!cookiesEnabled ? ' disabled' : '')
                    }
                    onClick={this.onClick}
                    disabled={!enabled}
                    tabIndex="0">
                    <FacebookIcon className="icon mr-2" />
                    {t('fblogin_withFacebook')}
                </button>
            </Fragment>
        );
    }
}

FacebookLoginButton.propTypes = {
    facebookAppId: PropTypes.string,
    isModal: PropTypes.bool
};

export default withTranslator(FacebookLoginButton);
